module.exports = __webpack_public_path__ + "static/media/usd.67442b38.svg";